import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAssetDefault = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <rect
      width={11.2}
      height={11.2}
      x={4.4}
      y={4.4}
      fill="url(#Asset_Default_svg__a)"
      fillOpacity={0.5}
      opacity={0.9}
      rx={2.56}
    />
    <path
      fill="url(#Asset_Default_svg__b)"
      fillOpacity={0.25}
      d="m10 10 3.961-3.961c.605-.605 1.639-.177 1.639.679v6.322a2.56 2.56 0 0 1-2.56 2.56H6.718c-.856 0-1.284-1.034-.68-1.639z"
    />
    <defs>
      <linearGradient
        id="Asset_Default_svg__a"
        x1={13.5}
        x2={-0.5}
        y1={12.625}
        y2={12.333}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale06)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale02)"
        />
      </linearGradient>
      <linearGradient
        id="Asset_Default_svg__b"
        x1={13.5}
        x2={-0.5}
        y1={12.625}
        y2={12.333}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale06)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale02)"
        />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgAssetDefault;
